import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('access_token');
  const router = inject(Router);

  if (token) {
    let headers = req.headers.set('Authorization', `Bearer ${token}`);

    const simulatedMagasinId = localStorage.getItem('simulated_magasin_id');
    if (simulatedMagasinId) {
      headers = headers.set('X-Simulate-Magasin', simulatedMagasinId);
    }

    const clonedReq = req.clone({ headers });

    return next(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Si le token est invalide ou expiré (401 Unauthorized)
        if (error.status === 401) {
          // Nettoyer le localStorage
          localStorage.removeItem('access_token');
          localStorage.removeItem('current_user');

          // Rediriger vers le login
          router.navigate(['/login']);
        }

        return throwError(() => error);
      })
    );
  }

  return next(req);
};
